import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor() { }

  success(title: string, message: string) {
    Swal.fire({
      position: 'top-end',
      html: `
        <div style="
          display: flex;
          align-items: center;
          justify-content: space-between;
          background-color: #f6fff6;
          border: 1.5px solid #a3e6a3;
          border-radius: 8px;
          padding: 10px 16px;
          width: 100%;
          min-width: 350px;
          max-width: 400px;
          box-shadow: 0 2px 6px rgba(0,0,0,0.1);
          font-family: 'Segoe UI', sans-serif;
          box-sizing: border-box;
        ">
        <img src="assets/svg/success-alert.svg" alt="éxito" style="width: 28px; height: 28px; margin-right: 12px;">
        <div style="flex: 1; text-align: left;">
          <div style="font-weight: 600; color: #2d662d; font-size: 16px;">${title}</div>
          <div style="color: #333; font-size: 14px;">${message}</div>
        </div>
        <div id="closeSwal" style="
          border: none;
          background: none;
          color: #666;
          font-size: 20px;
          line-height: 1;
          cursor: pointer;
        ">&times;</div>
        </div>
      `,
      background: 'transparent',
      showConfirmButton: false,
      timer: 5000,
      backdrop: false,
      customClass: {
        popup: 'swal-toast-container'
      },
      didOpen: () => {
        const popup: any = Swal.getPopup();
        popup.style.padding = '0';
        popup.style.background = 'transparent';
        popup.style.boxShadow = 'none';
        popup.style.width = 'auto';
        popup.style.maxWidth = 'none';

        document.getElementById('closeSwal')?.addEventListener('click', () => {
          Swal.close();
        });
      }
    });
  }

  error(title: string, message: string) {
    Swal.fire({
      position: 'top-end',
      html: `
        <div style="
          display: flex;
          align-items: center;
          justify-content: space-between;
          background-color: #fff6f6;
          border: 1.5px solid #e6a3a3;
          border-radius: 8px;
          padding: 10px 16px;
          width: 100%;
          min-width: 350px;
          max-width: 400px;
          box-shadow: 0 2px 6px rgba(0,0,0,0.1);
          font-family: 'Segoe UI', sans-serif;
          box-sizing: border-box;
        ">
        <img src="assets/svg/error-alert.svg" alt="error" style="width: 28px; height: 28px; margin-right: 12px;">
        <div style="flex: 1; text-align: left;">
          <div style="font-weight: 600; color: #662d2d; font-size: 16px;">${title}</div>
          <div style="color: #333; font-size: 14px;">${message}</div>
        </div>
        <div id="closeSwal" style="
          border: none;
          background: none;
          color: #666;
          font-size: 20px;
          line-height: 1;
          cursor: pointer;
        ">&times;</div>
        </div>
      `,
      background: 'transparent',
      showConfirmButton: false,
      timer: 5000,
      backdrop: false,
      customClass: {
        popup: 'swal-toast-container'
      },
      didOpen: () => {
        const popup: any = Swal.getPopup();
        popup.style.padding = '0';
        popup.style.background = 'transparent';
        popup.style.boxShadow = 'none';
        popup.style.width = 'auto';
        popup.style.maxWidth = 'none';

        document.getElementById('closeSwal')?.addEventListener('click', () => {
          Swal.close();
        });
      }
    });
  }

  warning(title: string, message: string) {
    Swal.fire({
      position: 'top-end',
      html: `
        <div style="
          display: flex;
          align-items: center;
          justify-content: space-between;
          background-color: #fffcf6;
          border: 1.5px solid #e6d4a3;
          border-radius: 8px;
          padding: 10px 16px;
          width: 100%;
          min-width: 350px;
          max-width: 400px;
          box-shadow: 0 2px 6px rgba(0,0,0,0.1);
          font-family: 'Segoe UI', sans-serif;
          box-sizing: border-box;
        ">
        <img src="assets/svg/warning-alert.svg" alt="advertencia" style="width: 28px; height: 28px; margin-right: 12px;">
        <div style="flex: 1; text-align: left;">
          <div style="font-weight: 600; color: #664d2d; font-size: 16px;">${title}</div>
          <div style="color: #333; font-size: 14px;">${message}</div>
        </div>
        <div id="closeSwal" style="
          border: none;
          background: none;
          color: #666;
          font-size: 20px;
          line-height: 1;
          cursor: pointer;
        ">&times;</div>
        </div>
      `,
      background: 'transparent',
      showConfirmButton: false,
      timer: 5000,
      backdrop: false,
      customClass: {
        popup: 'swal-toast-container'
      },
      didOpen: () => {
        const popup: any = Swal.getPopup();
        popup.style.padding = '0';
        popup.style.background = 'transparent';
        popup.style.boxShadow = 'none';
        popup.style.width = 'auto';
        popup.style.maxWidth = 'none';

        document.getElementById('closeSwal')?.addEventListener('click', () => {
          Swal.close();
        });
      }
    });
  }

  info(title: string, message: string) {
    Swal.fire({
      position: 'top-end',
      html: `
        <div style="
          display: flex;
          align-items: center;
          justify-content: space-between;
          background-color: #f6faff;
          border: 1.5px solid #a3c9e6;
          border-radius: 8px;
          padding: 10px 16px;
          width: 100%;
          min-width: 350px;
          max-width: 400px;
          box-shadow: 0 2px 6px rgba(0,0,0,0.1);
          font-family: 'Segoe UI', sans-serif;
          box-sizing: border-box;
        ">
        <img src="assets/svg/info-alert.svg" alt="información" style="width: 28px; height: 28px; margin-right: 12px;">
        <div style="flex: 1; text-align: left;">
          <div style="font-weight: 600; color: #2d4d66; font-size: 16px;">${title}</div>
          <div style="color: #333; font-size: 14px;">${message}</div>
        </div>
        <div id="closeSwal" style="
          border: none;
          background: none;
          color: #666;
          font-size: 20px;
          line-height: 1;
          cursor: pointer;
        ">&times;</div>
        </div>
      `,
      background: 'transparent',
      showConfirmButton: false,
      timer: 5000,
      backdrop: false,
      customClass: {
        popup: 'swal-toast-container'
      },
      didOpen: () => {
        const popup: any = Swal.getPopup();
        popup.style.padding = '0';
        popup.style.background = 'transparent';
        popup.style.boxShadow = 'none';
        popup.style.width = 'auto';
        popup.style.maxWidth = 'none';

        document.getElementById('closeSwal')?.addEventListener('click', () => {
          Swal.close();
        });
      }
    });
  }
}